module.exports = __webpack_public_path__ + "static/media/29ADMSPC26.ea56eb56.jpg";